<div class="container">
    <div class="error-container">
        <div class="error-content">
            <h1 class="heading-text">Oops!</h1>
            <div class="p-description">
                <p>Sorry about that... The page you are looking for could not be found. You can try to search or return to the homepage.</p>
            </div>
            <div class="action-rows">
                <button class="link-chevron"><span>Go to Homepage</span><mat-icon fontSet="material-symbols-outlined"> chevron_right </mat-icon></button>
            </div>
        </div>

        <div class="error-illustration">
            <img src="assets/images/Illustrations-oops.svg" alt="Opps">
        </div>
    </div>
</div>